import { backendFetch } from '../../../backend/backend';
import React, { useEffect, useState, Fragment } from 'react';
import { TableRow, Grid } from '@mui/material';
import { TSCell, TSTable } from '../../ui/TableStructure';

const StatsGames=()=>{


    const StatsRows=({stats,numeratorFn,denominatorFn})=>(
        stats.sort((a,b)=>numeratorFn(b)/denominatorFn(b)-numeratorFn(a)/denominatorFn(a)).map((a)=>(
            <TableRow key={a.player}>
                <TSCell>{a.player}</TSCell>
                <TSCell>{`${numeratorFn(a)}/${denominatorFn(a)}`}</TSCell>
                <TSCell>{`${(numeratorFn(a)*100/denominatorFn(a)).toFixed(1)}%`}</TSCell>
            </TableRow>
        ))
    )

    const [gamesStats,setGamesStats]=useState();
    useEffect(()=>{
        const fetchData=async ()=>{
            const gamesStats=await backendFetch('stats/games');
            setGamesStats(gamesStats);
        }
        fetchData();
    },[]);

    const GamesGridItem=({children})=>(
        <Grid item xs={12} sm={6} md={4} paddingBottom={1} paddingRight={1}>
            {children}
        </Grid>
    );

    return(
        <Fragment>
            {gamesStats && 
            <Grid container columns={12}>
                <GamesGridItem>
                    <TSTable title="Most Likely to Win" headings={["Player","Wins","Wins%"]}>
                        <StatsRows stats={gamesStats} numeratorFn={(a)=>a.wins} denominatorFn={(b)=>b.games}/>
                    </TSTable>
                </GamesGridItem>
                <GamesGridItem>
                    <TSTable title="Most Likely to Lose" headings={["Player","Losses","Losses%"]}>
                        <StatsRows stats={gamesStats} numeratorFn={(a)=>a.losses} denominatorFn={(b)=>b.games}/>
                    </TSTable>
                </GamesGridItem>
                <GamesGridItem>
                    <TSTable title="Least Wins/Losses" headings={["Player","Boredom","Boredom%"]}>
                        <StatsRows stats={gamesStats} numeratorFn={(a)=>(a.games-a.wins-a.losses)} denominatorFn={(a)=>a.games}/>
                    </TSTable>
                </GamesGridItem>
                <GamesGridItem>
                    <TSTable title="Best Attendance" headings={["Player","Attendance","Attendance%"]}>
                        <StatsRows stats={gamesStats} numeratorFn={(a)=>a.games} denominatorFn={(a)=>(a.games+a.noShows)}/>
                    </TSTable>
                </GamesGridItem>
                <GamesGridItem>
                    <TSTable title="Most Heads Ups" headings={(["Player","Heads Up","Heads Up%"])}>
                        <StatsRows stats={gamesStats} numeratorFn={(a)=>a.headsUp} denominatorFn={(a)=>a.games}/>
                    </TSTable>
                </GamesGridItem>
                <GamesGridItem>
                    <TSTable title="Best Heads Up Ratio" headings={(["Player","Wins","Wins%"])}>
                        <StatsRows stats={gamesStats} numeratorFn={(a)=>a.wins} denominatorFn={(a)=>a.headsUp}/>
                    </TSTable>
                </GamesGridItem>
            </Grid>
            }
        </Fragment>
    );
}

export default StatsGames;
